import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonSearchbar } from '@ionic/angular';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { BASE_CONFIG } from 'src/app/util/base-settings';
import { COMPONENT_NAME } from 'src/app/util/constants';
import { UtilFunctions } from 'src/app/util/util';

@Component({
  selector: 'a24-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {

  @Input() fileName: string = '';
  @Input() className: string = '';
  @Input() searchLs: any[];      // data from table
  @Input() searchBy: any[];   // table columns object
  @Input() isCustomSearch: boolean = false;
  @Input() isDisabled : boolean = false;
  @Input() customSearchOpt: any;
  @Input() isAPISearch: boolean = false;
  @Input() isFocus : boolean = false;
  @Input() searchBoxValue: string = "";
  @Input() isReset: boolean = false;
  @Input() placeholder: string = $localize`:@@searchComp.placeTxt:Search`;
  @Input() iconName : string = "search-outline";
  @Input() sourceObj: any[];
  
  @Output() retValue = new EventEmitter<any>();
  ACTIVE: string = 'Active';
  INACTIVE: string = 'Inactive';
  searchBox: HTMLInputElement;
  id: string = '';
  selValue: string;
  isWeb: boolean = BASE_CONFIG.IS_WEB;
  @ViewChild('searchText') searchbar : IonSearchbar;
  constructor(
    private logger : LoggerService,
    private util : UtilFunctions
  ) { }
  async ngAfterViewInit(): Promise<void>
  {
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("ngAfterViewInit");
      this.searchBox =await this.searchbar.getInputElement();
      // this.searchBox = document.getElementById(this.id) as HTMLInputElement;
      if (this.searchBox)
      {
        // ionChange
        let search = fromEvent(this.searchBox, 'input').pipe(
          map(e => (e.target as HTMLInputElement).value),
          filter(text => text.length > 0 || text == ''),
          debounceTime(10),
          // distinctUntilChanged(),
          switchMap(async (searchTerm) => this.isWeb ? this.webSearchValues(searchTerm) : this.searchValues(searchTerm))
        );
        search.subscribe();
      }
      if(this.isFocus)
        this.searchbar.setFocus();
    }
    catch (err)
    {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.SEARCH_COMPONENT,
        "error in ngAfterViewInit",
        err.toString(),
        "ngAfterViewInit"
      );
      this.logger.log(logRequest);
    }
  }
  clearSearch(pEvent){
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("clearSearch");
      if (this.isWeb) {
        this.webSearchValues('');
      } else {
        this.searchValues('');
      }
    }
    catch (err)
    {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.SEARCH_COMPONENT,
        "error in clearSearch",
        err.toString(),
        "clearSearch"
      );
      this.logger.log(logRequest);
    }
  }
  ngOnInit(): void
  {

    this.id = this.fileName + 'search-box';
    // if(this.searchBoxValue && document.getElementById("search-box"))
    //   document.getElementById("search-box").innerHTML = this.searchBoxValue
  }


  searchValues(pSearchChars: string | number)
  {
    try
    {
      if (BASE_CONFIG.IS_DEBUG) console.log("searchValues");
      let searchChars = pSearchChars.toString();
      // if (this.isAPISearch)
      // {
      //   this.retValue.emit(searchChars);
      // }
      // else
      // {

        let outLs: any[] = [];
        if (searchChars == '')
        {
          this.retValue.emit({ searchList : this.searchLs, searchKey : searchChars});
        }
        else
        {
          for (let row of this.searchLs)
          {
            loopB: for (let key of Object.keys(row))
            {
              if (key === "__typename") continue;
              if (String(row[key]).toLowerCase().includes(searchChars.toLowerCase()))
              {
                outLs.push(row);
                break loopB;
              }
            }
          }
          this.retValue.emit({ searchList : outLs, searchKey : searchChars});
        }
      // }
    }
    catch (err)
    {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.SEARCH_COMPONENT,
        "error in searchValues",
        err.toString(),
        "searchValues"
      );
      this.logger.log(logRequest);
    }
  }

  webSearchValues(pSearchChars: string | number) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("webSearchValues");
      let searchChars = pSearchChars.toString();

        if (searchChars == '')
        {
          this.retValue.emit({ searchList : this.sourceObj, searchKey : searchChars});
        }
        else
        {
          let obj: any = {};
          for (const key in this.sourceObj) {
            if (this.sourceObj.hasOwnProperty(key)) {
              let outLs: any[] = [];
              for (let row of this.sourceObj[key])
              {
                loopB: for (let key of Object.keys(row))
                {
                 
             
                  if (String(row[key]).toLowerCase().includes(searchChars.toLowerCase()))
                      {
                        outLs.push(row);
                        break loopB;
                      }
                }
              }
              obj[key] = outLs;
            }
          }
          this.retValue.emit({ searchList : obj, searchKey : searchChars});
        }
    } catch (error) {
      this.util.logFunc('webSearchValues', error, COMPONENT_NAME.SEARCH_COMPONENT);
    }
  }

}
